import { ChangeDetectionStrategy, Component, ElementRef, TemplateRef, computed, inject, input } from '@angular/core';

import { v4 as uuid } from 'uuid';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { TabsComponent } from '../tabs/tabs.component';
import { TabIconPosition } from '../tabs/enums';

export interface TabIcon {
  name: SvgLibraryIcon;
  position: TabIconPosition;
}

@Component({
  selector: 'fcom-tab',
  templateUrl: './tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TabComponent {
  private readonly tabsComponent = inject(TabsComponent);

  readonly tabId = `fcom-tab-${uuid()}`;
  readonly isActive = computed(() => this.tabsComponent.activeTabId() === this.tabId);

  active = input<boolean>(false);
  disabled = input<boolean>(false);
  title = input.required<string>();
  subtitle = input<string>();
  contentPopover = input<TemplateRef<ElementRef>>();
  data = input<unknown>();
  tabTitleDataTestId = input<string>();
  icon = input<TabIcon>({ name: '' as SvgLibraryIcon, position: TabIconPosition.TOP });
}
